import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

interface ButtonProps {
    type?: string;
    btnType?: string;
    text?: string;
    onClick?: (event: Event) => void;
  }

@Component({
  selector: 'formly-field-button',
  template: `
    <div>
      <button 
        [type]="props['type']" 
        [ngClass]="'btn btn-' + props['btnType']" 
        (click)="onClick($event)">
        {{ props['text'] }}
      </button>
    </div>
  `,
  standalone:true,
  imports:[
    CommonModule,FormsModule,
  ]
})
export class FormlyFieldButton extends FieldType {
  onClick($event: Event) {
    if (this.props['onClick']) {
      this.props['onClick']($event);
    }
  }
}
